/* code for events single view autocomplete */
    /* Adapted from https://www.youtube.com/watch?v=c3MjU9E9buQ */
let autocomplete;
let place;
let autocompleteID;
let ticketsBodyView;
let locationBasedPricingEnabled;

window.initAutocomplete = () => {
    ticketsBodyView = document.getElementById('tribe-tickets__tickets-form');
    autocompleteID = document.getElementById('autocompleteEventAddressBar');
    if ( autocompleteID ) {  
        //show or hide tickets div
        showOrHideTicketsDiv();  
        //google functions            
        autocomplete = new google.maps.places.Autocomplete(
            autocompleteID,            {
            types: [],
            componentRestrictions: {'country': ['US']},
            fields: ['place_id', 'geometry', 'name', 'formatted_address']
        });
        //event listeners
        autocomplete.addListener('place_changed', onPlaceChanged);
        autocompleteID.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                alert('Please select home address from provided suggestions.');
            }
        });
    }
}// end initAutocomplete

function showOrHideTicketsDiv(){
    locationBasedPricingEnabled = document.querySelectorAll('[data-post-location-based-pricing="1"]');
    ticketsBodyView = document.getElementById('tribe-tickets__tickets-form');
    if ( !locationBasedPricingEnabled ) {
        ticketsBodyView.style.display = "block";
        $('#tribe-tickets__tickets-form-headline').show(); //get tickets headline
    }

}// end showOrHideTicketsDiv

window.onPlaceChanged = () => {
    place = autocomplete.getPlace();
    if (!place.geometry) {
        document.getElementById('autocompleteEventAddressBar').placeholder = 'Enter your home address';
    } else {
        //show the loading animation
        let loadImage = document.getElementById('autocompleteEventLoadingImg');
        loadImage.style.display = "block";
        fetch(COMMON_PARAMS.ajaxUrl+'?action=in_district_check&lat='+
            place.geometry.location.lat()+'&lng='+
            place.geometry.location.lng())
        .then( response => response.json() )
        .then( data => {
            localStorage.setItem('inOrOutOfDistrictBool', data['in_district']);
            showOrHideTicketsBasedOnLocale(); 
        } )
        .finally( () => {
            loadImage.style.display = "none";
        } );

        //show formatted address to user after selection
        document.getElementById('autocompleteEventAddressResults').innerHTML = place.formatted_address;
        
    }
}//end onPlaceChanged
/* end code for events single view autocomplete */

/* code for showing or hiding events based on in/out of district */
function showOrHideTicketsBasedOnLocale() {
    //declare vars
    let inOrOutOfDistrictBoolFromLocalStorage = localStorage.getItem('inOrOutOfDistrictBool');
    let inDistrictTicketDivs = document.querySelectorAll('[data-ticket-is-in-district="1"]');
    let outOfDistrictTicketDivs = document.querySelectorAll('[data-ticket-is-in-district="0"]');
    let districtTicketDivsToShow;
    let districtTicketDivsToHide;

    if ( ticketsBodyView && inOrOutOfDistrictBoolFromLocalStorage ) {
        ticketsBodyView.style.display = "block";
        $('#tribe-tickets__tickets-form-headline').show(); //get tickets headline
        //sort based on locale boolean
        if ( inOrOutOfDistrictBoolFromLocalStorage === 'true' ) {
            districtTicketDivsToShow = inDistrictTicketDivs;
            districtTicketDivsToHide = outOfDistrictTicketDivs;
        } else {
            districtTicketDivsToHide = inDistrictTicketDivs;
            districtTicketDivsToShow = outOfDistrictTicketDivs;
        }
        //show and hide calls
        districtTicketDivsToShow.forEach(function(ticketDiv) {
            ticketDiv.style.display = "";
        });
        districtTicketDivsToHide.forEach(function(ticketDiv) {
            ticketDiv.style.display = "none";
        });
    }
}
/* end code for showing or hiding events based on in/out of district */